const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Resolve a stored image URL. Prepends backend URL for relative /api/files paths. */
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
